import Tippy from '@tippyjs/react';
import type { ExtendedViewership } from '../types';

export function getStationCellRenderer({ data }: { data: ExtendedViewership }) {
  const station = data.station ?? data.watchStation;
  const resizedImage = station?.image?.replace(/w=\d+&h=\d+/, 'w=32&h=24');

  return (
    <Tippy
      content={station?.displayName}
      placement="top"
      arrow
      delay={100}
      animation="shift-toward"
    >
      <div className="station__cell__container">
        {resizedImage && (
          <img
            className="station-logo"
            src={resizedImage}
            alt={station?.displayName}
          />
        )}
        <span>{station?.displayName}</span>
      </div>
    </Tippy>
  );
}
